export default __webpack_public_path__ + "img/default-user.7fe14f0a.jpg";